'use es6';

import RecordFactory from '../RecordFactory';
export default RecordFactory({
  id: null,
  accountId: null,
  adGroupId: null,
  campaignId: null,
  creativeId: null,
  network: null,
  name: null,
  status: null,
  effectiveStatus: null,
  imageUrl: null,
  headline: null,
  body: null,
  cta: null,
  formId: null,
  websiteUrl: null,
  urlParameters: null,
  pageId: null,
  previousState: null
});